<template>
  <div>
    <div v-if="!make" data-anima="top">
      <div class="flex-header">
        <div>
          <h5>{{ $t('views.cobranca.text_2132') }}</h5>
          <p>{{ $t('views.cobranca.text_891') }}</p>
        </div>
        <BaseButton @click="(make = true), reset(), makeNew(), changeParcelasSub()" variant="outline-info"
          v-if="!isMobile">{{ $t('views.cobranca.text_892') }}</BaseButton>
        <!-- <BaseButton
          variant="outline-info"
          v-b-tooltip.title="validStatusNew()"
          v-if="!isMobile && validStatusNew()"
          >Novo preço</BaseButton
        > -->
      </div>
      <div class="info-value" data-anima="top">
        <div class="value-base">
          <p>{{ $t('views.cobranca.text_893') }}</p>
          <svg id="preco_base" width="17" height="17" viewBox="0 0 17 17" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.61 6.00112C5.47255 6.39186 5.67788 6.82005 6.06862 6.9575C6.45936 7.09495 6.88755 6.88962 7.025 6.49888L5.61 6.00112ZM10.69 7L9.94 6.99888V7H10.69ZM8.20283 8.53849C7.80987 8.66947 7.5975 9.09421 7.72849 9.48717C7.85947 9.88013 8.28421 10.0925 8.67717 9.96151L8.20283 8.53849ZM8.5 11.5C8.08579 11.5 7.75 11.8358 7.75 12.25C7.75 12.6642 8.08579 13 8.5 13V11.5ZM8.5075 13C8.92171 13 9.2575 12.6642 9.2575 12.25C9.2575 11.8358 8.92171 11.5 8.5075 11.5V13ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.025 6.49888C7.14255 6.16472 7.37458 5.88294 7.67998 5.70345L6.91995 4.41025C6.30915 4.76922 5.8451 5.33279 5.61 6.00112L7.025 6.49888ZM7.67998 5.70345C7.98538 5.52396 8.34445 5.45835 8.69359 5.51824L8.94718 4.03983C8.24889 3.92006 7.53076 4.05128 6.91995 4.41025L7.67998 5.70345ZM8.69359 5.51824C9.04273 5.57813 9.35941 5.75964 9.58754 6.03065L10.7351 5.06465C10.2788 4.52264 9.64546 4.1596 8.94718 4.03983L8.69359 5.51824ZM9.58754 6.03065C9.81567 6.30165 9.94053 6.64464 9.94 6.99888L11.44 7.00112C11.4411 6.29264 11.1913 5.60665 10.7351 5.06465L9.58754 6.03065ZM9.94 7C9.94 7.35185 9.66617 7.71866 9.14898 8.06346C8.9132 8.22065 8.67208 8.34174 8.48696 8.42402C8.39546 8.46468 8.32026 8.49471 8.26968 8.51398C8.24446 8.52359 8.22555 8.53045 8.21401 8.53455C8.20825 8.5366 8.20434 8.53795 8.20243 8.53861C8.20148 8.53894 8.20102 8.53909 8.20108 8.53907C8.20111 8.53906 8.20127 8.53901 8.20156 8.53891C8.20171 8.53886 8.20188 8.5388 8.2021 8.53873C8.2022 8.5387 8.20238 8.53864 8.20244 8.53862C8.20263 8.53855 8.20283 8.53849 8.44 9.25C8.67717 9.96151 8.67739 9.96144 8.67761 9.96136C8.6777 9.96134 8.67794 9.96126 8.67811 9.9612C8.67846 9.96108 8.67884 9.96095 8.67926 9.96081C8.6801 9.96053 8.68107 9.9602 8.68218 9.95983C8.6844 9.95907 8.68718 9.95813 8.69048 9.95699C8.69708 9.95472 8.70581 9.95168 8.71653 9.94787C8.73795 9.94026 8.76738 9.92954 8.80368 9.91571C8.87615 9.8881 8.97673 9.84782 9.09617 9.79473C9.33292 9.68951 9.6543 9.52935 9.98102 9.31154C10.5888 8.90634 11.44 8.14815 11.44 7H9.94ZM8.5 13H8.5075V11.5H8.5V13Z"
              fill="#81858E" />
          </svg>
          <b-tooltip target="preco_base" :title="$t('views.cobranca.text_2133')" placement="top" />
          <h2 class="mt-2">
            {{ filterCurrency(defaultValueCurrency) }}
            {{ formatMoney(+defaultValue) }}
          </h2>
        </div>

        <div class="value-base">
          <p>{{ $t('views.cobranca.text_894') }}</p>
          <svg id="garantia" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.61 6.00112C5.47255 6.39186 5.67788 6.82005 6.06862 6.9575C6.45936 7.09495 6.88755 6.88962 7.025 6.49888L5.61 6.00112ZM10.69 7L9.94 6.99888V7H10.69ZM8.20283 8.53849C7.80987 8.66947 7.5975 9.09421 7.72849 9.48717C7.85947 9.88013 8.28421 10.0925 8.67717 9.96151L8.20283 8.53849ZM8.5 11.5C8.08579 11.5 7.75 11.8358 7.75 12.25C7.75 12.6642 8.08579 13 8.5 13V11.5ZM8.5075 13C8.92171 13 9.2575 12.6642 9.2575 12.25C9.2575 11.8358 8.92171 11.5 8.5075 11.5V13ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.025 6.49888C7.14255 6.16472 7.37458 5.88294 7.67998 5.70345L6.91995 4.41025C6.30915 4.76922 5.8451 5.33279 5.61 6.00112L7.025 6.49888ZM7.67998 5.70345C7.98538 5.52396 8.34445 5.45835 8.69359 5.51824L8.94718 4.03983C8.24889 3.92006 7.53076 4.05128 6.91995 4.41025L7.67998 5.70345ZM8.69359 5.51824C9.04273 5.57813 9.35941 5.75964 9.58754 6.03065L10.7351 5.06465C10.2788 4.52264 9.64546 4.1596 8.94718 4.03983L8.69359 5.51824ZM9.58754 6.03065C9.81567 6.30165 9.94053 6.64464 9.94 6.99888L11.44 7.00112C11.4411 6.29264 11.1913 5.60665 10.7351 5.06465L9.58754 6.03065ZM9.94 7C9.94 7.35185 9.66617 7.71866 9.14898 8.06346C8.9132 8.22065 8.67208 8.34174 8.48696 8.42402C8.39546 8.46468 8.32026 8.49471 8.26968 8.51398C8.24446 8.52359 8.22555 8.53045 8.21401 8.53455C8.20825 8.5366 8.20434 8.53795 8.20243 8.53861C8.20148 8.53894 8.20102 8.53909 8.20108 8.53907C8.20111 8.53906 8.20127 8.53901 8.20156 8.53891C8.20171 8.53886 8.20188 8.5388 8.2021 8.53873C8.2022 8.5387 8.20238 8.53864 8.20244 8.53862C8.20263 8.53855 8.20283 8.53849 8.44 9.25C8.67717 9.96151 8.67739 9.96144 8.67761 9.96136C8.6777 9.96134 8.67794 9.96126 8.67811 9.9612C8.67846 9.96108 8.67884 9.96095 8.67926 9.96081C8.6801 9.96053 8.68107 9.9602 8.68218 9.95983C8.6844 9.95907 8.68718 9.95813 8.69048 9.95699C8.69708 9.95472 8.70581 9.95168 8.71653 9.94787C8.73795 9.94026 8.76738 9.92954 8.80368 9.91571C8.87615 9.8881 8.97673 9.84782 9.09617 9.79473C9.33292 9.68951 9.6543 9.52935 9.98102 9.31154C10.5888 8.90634 11.44 8.14815 11.44 7H9.94ZM8.5 13H8.5075V11.5H8.5V13Z"
              fill="#81858E" />
          </svg>
          <b-tooltip target="garantia" :title="$t('views.cobranca.text_2134')" placement="top" />
          <h2 class="mt-2">{{ warranty ? warranty : 7 }} dias</h2>
        </div>
        <div class="value-base">
          <p>{{ $t('views.cobranca.text_2135') }}</p>
          <br />
          <h2 class="mt-2">
            {{ product.type === "SUBSCRIPTION" ? $t('views.cobranca.text_2136') : $t('views.cobranca.text_2137') }}
          </h2>
        </div>
      </div>
      <div class="mt-5" data-anima="top">
        <!-- HEADER -->
        <b-row class="Table-header mb-1" v-if="!isMobile">
          <b-col cols="3" class=""> {{ $t('views.cobranca.text_2138') }} </b-col>

          <b-col cols="2" class=""> {{ $t('views.cobranca.text_2139') }} </b-col>

          <b-col cols="2" class=""> {{ $t('views.cobranca.text_2141') }} </b-col>

          <!-- <b-col cols="3" class="d-none"> Método de pagamento </b-col> -->
          <b-col cols="3" class=""></b-col>

          <b-col cols="2" class=""> {{ $t('views.cobranca.text_2140') }} </b-col>
        </b-row>
        <b-row class="Table-header mb-1" v-if="isMobile">
          <b-col cols="5" class=""> {{ $t('views.cobranca.text_2138') }} </b-col>

          <b-col cols="3" class=""> {{ $t('views.cobranca.text_2139') }} </b-col>

          <b-col cols="4" class=""> {{ $t('views.cobranca.text_2141') }} </b-col>
        </b-row>
        <!-- END HEADER -->

        <template v-if="!loading && offers.length > 0 && !isMobile">
          <b-row class="Table-body" v-for="(item, index) in offers" :key="item.id"
            :class="getStatus(item.status).class">
            <b-col id="id_venda" cols="3" class="d-none d-md-block text-table"
              v-b-tooltip="{ title: isLinkLocked ? 'Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro.' : getStatus(item.status).text }">
              <div :class="{ default: item.default === 1 }">
                {{ item.default === 1 ? "Preço base" : `#${item.name}` }}
              </div>
            </b-col>

            <b-col cols="2" class="d-none d-md-block text-table">
              {{ filterCurrency(item.currency_id) }}
              {{ formatMoney(+item.amount) }}
              <div class="offer-charge-type">{{ chargeTypeLabel(item) }}</div>
            </b-col>

            <b-col cols="2" class="d-none d-md-block text-table">
              {{ item.hash }}
            </b-col>

            <b-col cols="3" class="d-none d-md-block text-table" style="word-break: break-word">
              {{ getMethod(item.method) }}
            </b-col>

            <b-col cols="2" class="d-none d-md-block">
              <div class="flex-actions">
                <div>
                  <span class="btn p-2" v-if="
                    item.status !== 'DISAPPROVED' && product.status !== `PENDING` && product.status !== `DISAPPROVED` && product.status !== `REQUESTED`
                  " :id="'copy-alert-' + item.id" @click="onCopyClick(item)">
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                  <b-tooltip
                    v-if="isLinkLocked"
                    :target="'copy-alert-' + item.id"
                    title="Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro."
                  />
                  <span class="btn p-2" @click="editOffer(item)">
                    <img src="@/assets/img/icons/editar.svg" class="copy-link" />
                  </span>
                </div>
                <b-dropdown size="sm" top dropup variant="link" toggle-class="text-decoration-none" no-caret
                  class="drop-personalizado">
                  <template v-slot:button-content>
                    <img src="@/assets/img/icons/more.svg" class="btn-more" />
                  </template>

                  <b-dropdown-item v-if="
                    product.status !== 'REQUESTED' &&
                    product.status !== 'DISAPPROVED' &&
                    item.status !== 'PENDING' &&
                    item.status !== 'DISAPPROVED' &&
                    validStatus(item.status) &&
                    chargeTypeOf(item) === product.type
                  " class="drop-item" @click="changeDefault(item)">
                    {{ $t('views.cobranca.text_895') }}
                  </b-dropdown-item>

                  <!-- <b-dropdown-item
                    v-if="
                      item.status !== 'PENDING' &&
                      item.status !== 'DISAPPROVED' &&
                      validStatus(item.status)
                    "
                    class="drop-item"
                    @click="copyLink(item)"
                  >
                    Link desta oferta
                  </b-dropdown-item>

                  <b-dropdown-item class="drop-item" @click="editOffer(item)">
                    Editar
                  </b-dropdown-item> -->

                  <b-dropdown-item v-if="item.default === 0" class="drop-item" @click="deleteOffer(item, index)">
                    {{ $t('views.cobranca.text_897') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
        </template>

        <template v-if="!loading && offers.length > 0 && isMobile">
          <b-row class="Table-body" v-for="item in offers" :key="item.id">
            <b-col cols="5" class="text-table">
              <div :class="{ default: item.default === 1 }">
                {{ item.default === 1 ? "Preço base" : `#${item.name}` }}
              </div>
            </b-col>
            
            <b-col cols="3" class="text-table">
              {{ filterCurrency(item.currency) }}
              {{ formatMoney(+item.amount) }}
              <div class="offer-charge-type">{{ chargeTypeLabel(item) }}</div>
            </b-col>

            <b-col cols="4" class="text-table">
              {{ item.hash }}
            </b-col>
          </b-row>
        </template>

        <div v-if="loading" class="
            Table-body
            py-4
            d-flex
            justify-content-center
            align-items-center
          ">
          <b-spinner variant="dark" label="Spinning"></b-spinner>
        </div>

        <b-row v-if="!loading && !offers.length" class="Table-body justify-content-center">
          <p class="nao-encontrado">{{ $t('views.cobranca.text_898') }}</p>
        </b-row>
      </div>

      <b-modal v-model="showCheckoutLinksModal" title="Links do checkout" centered size="lg" hide-footer>
        <template v-if="selectedCheckoutOffer">
          <CopyLinkCard
            v-if="checkoutLinkByHash"
            :url="checkoutLinkByHash"
            title="Novo link recomendado"
            description="Oculta o ID sequencial do produto. Prefira este link em novas divulgações."
            copy-label="Copiar recomendado"
            recommended
            @open="openCheckoutLink"
            @copy="copyCheckoutLink"
          />
          <div v-else class="checkout-link-loading">
            Preparando o novo link seguro...
          </div>

          <CopyLinkCard
            :url="checkoutLinkById"
            title="Link atual"
            description="Mantém o formato que você já usa para compatibilidade."
            copy-label="Copiar link atual"
            @open="openCheckoutLink"
            @copy="copyCheckoutLink"
          />
        </template>
      </b-modal>
    </div>
    <div v-else data-anima="top">
      <div class="flex-header">
        <div data-anima="top">
          <h5 class="pointer" @click="voltar()">
            <svg class="arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.46967 9.53033C4.76256 9.82322 5.23744 9.82322 5.53033 9.53033C5.82322 9.23744 5.82322 8.76256 5.53033 8.46967L4.46967 9.53033ZM1 5L0.46967 4.46967C0.176777 4.76256 0.176777 5.23744 0.46967 5.53033L1 5ZM5.53033 1.53033C5.82322 1.23744 5.82322 0.762563 5.53033 0.46967C5.23744 0.176777 4.76256 0.176777 4.46967 0.46967L5.53033 1.53033ZM5.53033 8.46967L1.53033 4.46967L0.46967 5.53033L4.46967 9.53033L5.53033 8.46967ZM1.53033 5.53033L5.53033 1.53033L4.46967 0.46967L0.46967 4.46967L1.53033 5.53033Z"
                fill="#002363" />
            </svg>

            {{ $t('views.cobranca.text_892') }}
          </h5>
          <p>
            {{ $t('views.cobranca.text_899') }}
          </p>
        </div>
      </div>
      <b-form novalidate v-if="!loading">
        <div class="mt-4">
          <b-row>
            <b-col cols="12" md="12" class="mb-3" data-anima="top">
              <b-form-group :label="$t('views.cobranca.text_900')" label-for="name">
                <b-form-input name="name" v-model="name" type="text" v-validate="'required'"
                  :placeholder="$t('views.cobranca.text_901')"></b-form-input>
                <b-form-invalid-feedback :state="!errors.has('name')">
                  {{ $t('views.cobranca.text_902') }}
                </b-form-invalid-feedback>
                <p class="mb-1">
                  {{ $t('views.cobranca.text_2142') }}
                </p>
              </b-form-group>
            </b-col>
            <!-- Charge type: escolha só na criação (beta); na edição, só leitura -->
            <b-col v-if="canChooseChargeType || editItem" cols="12" md="6" class="mb-3" data-anima="top">
              <b-form-group :label="$t('views.cobranca.text_2135')" label-for="charge_type">
                <b-form-select v-if="canChooseChargeType" id="charge_type" name="charge_type" v-model="charge_type"
                  :options="chargeTypeOptions" @change="onChargeTypeChange"></b-form-select>
                <p v-else id="charge_type_label" class="charge-type-label">{{ chargeTypeLabel(editItem) }}</p>
              </b-form-group>
            </b-col>
            <!-- Currency -->
            <b-col v-if="renderComponent && interAccess" cols="12" md="6" class="mb-3">
              <b-form-group label="Moeda" label-for="method" class="mr-3">
                <b-form-select v-model="currencie_id" :options="currencies" value-field="id"
                  :disabled="offerChargeType === 'SUBSCRIPTION'" text-field="name"
                  @change="changeCurrency"></b-form-select>
              </b-form-group>
              <p class="mb-2" style="margin-top: -8px;" v-if="product.smart_sale && offerChargeType !== 'SUBSCRIPTION'">
                A venda inteligente funciona apenas se a moeda for Real Brasileiro.
              </p>
            </b-col>
            <!-- Price -->
            <b-col cols="12" md="6" data-anima="top" class="pr-3 mb-3">
              <b-form-group id="amount-container" :label="$t('views.cobranca.text_2132')" label-for="amount">
                <money class="w-100" :disabled="disableEditPrice" id="amount" v-model="amount" v-bind="money"></money>
                <small
                  v-if="posGraduationMinPrice !== null"
                  id="pos-graduation-min-price-hint"
                  :class="posGraduationAmountInvalid ? 'text-danger' : 'text-muted'"
                >
                  {{ $t("views.cobranca.pos_graduation_min_price_hint") }}
                  {{ posGraduationMinPriceLabel }}
                </small>
              </b-form-group>
              <b-tooltip v-if="editOfferIsDisable" target="amount-container" :title="$t('views.cobranca.text_2143')" />
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="12" md="4" class="pr-3" v-if="offerChargeType == 'SUBSCRIPTION'" data-anima="top">
              <b-form-group :label="$t('views.cobranca.text_2144')" label-for="period">
                <b-form-select id="period" name="period" v-model="period" v-validate="'alpha_num'"
                  @change="changeParcelasSub" :options="periods"></b-form-select>

                <b-form-invalid-feedback :state="!errors.has('period')">
                  {{ $t('views.cobranca.text_2145') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="4" class="pr-3" v-if="offerChargeType == 'SUBSCRIPTION'" data-anima="top">
              <b-form-group :label="$t('views.cobranca.text_2146')" label-for="trial">
                <b-form-input id="trial" name="trial" v-model="trial" type="number"
                  :placeholder="$t('views.cobranca.text_2147')" v-validate="'alpha_num'"></b-form-input>
                <b-form-invalid-feedback :state="!errors.has('trial')">
                  {{ $t('views.cobranca.text_2145') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4" v-if="offerChargeType == 'SUBSCRIPTION'">
              <b-form-group :label="$t('views.cobranca.text_2148')" label-for="charges">
                <b-form-input name="charges" v-model="charges" type="number"
                  :placeholder="$t('views.cobranca.text_2149')" v-validate="'alpha_num'"></b-form-input>

                <div class="mark-down mt-2" v-if="product.charges" data-anima="top">
                  <p class="info-mark">
                    {{ $t('views.cobranca.text_2150') }} {{ charges }}x {{ $t('views.cobranca.text_2151') }}
                  </p>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="renderComponent" class="mb-3">
            <b-col cols="12" md="12">
              <b-form-group :label="$t('views.cobranca.text_2152')" label-for="method">  
                <multiselect v-model="method" :options="filterBy(methods_)" :value="method" :multiple="true"
                  :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                  :placeholder="$t('views.cobranca.text_2152')" label="name" track-by="name" selectLabel=""
                  deselectLabel="" selectedLabel="✔︝" class="multi-select-input" id="multi_select_metodo"
                  :option-disabled="isMethodDisabled">
                  <template slot="option" slot-scope="props">
                    <span :class="{ 'method-disabled': props.option.$isDisabled }">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="viewInstallment">
            <b-row class="mt-2" v-if="period !== 30">
              <b-col cols="12" md="6" data-anima="top" class="pr-3" v-if="fixed_installments === null">
                <b-form-group :label="$t('views.cobranca.text_904')" label-for="max_installments"
                  v-if="offerChargeType !== 'SUBSCRIPTION'">
                  <b-form-select id="max_installments" name="max_installments" v-model="max_installments"
                    @change="changeParcelasCard()" :options="option_cc_installments"
                    v-validate="'required'"></b-form-select>
                  <b-form-invalid-feedback :state="!errors.has('max_installments')">
                    {{ $t('views.cobranca.text_905') }}
                  </b-form-invalid-feedback>

                  <div class="mark-down">
                    <p class="info-mark">
                      {{ $t('views.cobranca.text_2155') }}
                    </p>
                  </div>
                </b-form-group>
                <b-form-group :label="$t('views.cobranca.text_2154')" label-for="subscription_installments" v-else>
                  <b-form-select id="subscription_installments" name="subscription_installments"
                    v-model="max_subscription_installments" :options="subscription_installments"
                    v-validate="'required'"></b-form-select>
                  <div class="mark-down mb-3">
                    <p class="info-mark">
                      {{ $t('views.cobranca.text_2155') }}
                    </p>
                  </div>

                  <b-form-invalid-feedback :state="!errors.has('subscription_installments')">
                    {{ $t('views.cobranca.text_905') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" data-anima="top">
                <b-form-group :label="$t('views.cobranca.text_2153')" label-for="fixed_installments">
                  <b-form-select id="fixed_installments" name="fixed_installments" v-model="fixed_installments"
                    :options="option_fixed_installments_"></b-form-select>
                  <div class="mark-down" v-if="fixed_installments">
                    <p class="info-mark">
                      {{ $t('views.cobranca.text_903') }}
                      {{ fixed_installments }}x
                    </p>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12" data-anima="top" class="mb-3" v-if="isShowPreSelectedInstallment()">
                <b-form-group label-for="pre_selected_installment">
                  <template #label>
                    <span id="tooltip_installment" style="cursor: help;">
                      {{ $t('views.cobranca.text_2156') }}
                      <font-awesome-icon icon="info-circle" class="ml-1" style="color: #81858E;" />
                    </span>
                  </template>
                  <b-form-select id="pre_selected_installment" name="pre_selected_installment"
                    v-model="pre_selected_installment" :options="option_pre_selected_installment"></b-form-select>
                  <div class="mark-down" v-if="pre_selected_installment">
                    <p class="info-mark">
                      {{ $t('views.cobranca.text_2157') }}
                      {{ pre_selected_installment }}x
                    </p>
                  </div>
                </b-form-group>
                <b-tooltip target="tooltip_installment" placement="top" triggers="hover">
                  {{ $t('views.cobranca.text_2158') }}
                </b-tooltip>
              </b-col>
            </b-row>
          </template>

          <b-row class="mt-2" v-if="isOfferWebhookBetaSeller">
            <b-col cols="12" md="6" data-anima="top" class="pr-3">
              <b-form-group :label="$t('views.cobranca.modality')" label-for="modality">
                <b-form-select id="modality" name="modality" v-model="modality"
                  :options="[{ value: null, text: $t('views.cobranca.select_modality'), disabled: true }, { value: 'EAD', text: $t('views.cobranca.ead') }]"
                  :placeholder="$t('views.cobranca.modality')"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" data-anima="top">
              <b-form-group :label="$t('views.cobranca.submodality')" label-for="submodality">
                <b-form-select id="submodality" name="submodality" v-model="submodality" :options="[
                  { value: null, text: $t('views.cobranca.select_submodality'), disabled: true },
                  { value: 'CEM_POR_CENTO_ONLINE', text: $t('views.cobranca.online') },
                  { value: 'SEMIPRESENCIAL', text: $t('views.cobranca.semipresencial') }
                ]" :placeholder="$t('views.cobranca.submodality')"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="mt-4" data-anima="top">
          <!-- Enrollment Fee (Adesão) - only for subscriptions  -->          
          <div v-if="offerChargeType === 'SUBSCRIPTION' && isEnrollmentBetaSeller && (!trial || trial == 0)">
              <div class="type">
                <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M1 5.5C0.447715 5.5 0 5.94772 0 6.5C0 7.05228 0.447715 7.5 1 7.5V5.5ZM18 7.5C18.5523 7.5 19 7.05228 19 6.5C19 5.94772 18.5523 5.5 18 5.5V7.5ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM18 2C18.5523 2 19 1.55228 19 1C19 0.447715 18.5523 0 18 0V2ZM1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13V11ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11V13ZM1 7.5H18V5.5H1V7.5ZM1 2H18V0H1V2ZM1 13H18V11H1V13Z"
                      fill="#81858E" />
                </svg>
                <div>
                  <h6>{{ $t('views.cobranca.enrollment_fee_title') }}</h6>
                  <p>
                      {{ $t('views.cobranca.enrollment_fee_description') }}
                  </p>
                </div>
                <b-form-checkbox v-model="has_enrollment_fee" name="has_enrollment_fee" size="lg" switch>
                </b-form-checkbox>
            </div>

            <b-row v-if="has_enrollment_fee">
              <b-col class="border-bottom mb-4 pb-4" cols="12">
                  <b-form-group :label="$t('views.cobranca.enrollment_fee_amount_label')" label-for="enrollment_amount" data-anima="top" class="col-md-4">
                      <money class="w-100" :class="{ 'is-invalid': has_enrollment_fee && enrollment_amount < 9 && enrollmentAmountTouched }" id="enrollment_amount" v-model="enrollment_amount" v-bind="money" @input.native="enrollmentAmountTouched = true"></money>
                      <b-form-invalid-feedback :state="!(has_enrollment_fee && enrollment_amount < 9 && enrollmentAmountTouched)">
                        {{ $t('views.cobranca.enrollment_fee_min_value') }} R$ 9,00
                      </b-form-invalid-feedback>
                  </b-form-group>
              </b-col>
            </b-row>
          </div>
          <!-- // -->

          <div v-if="validMethod() && offerChargeType != 'SUBSCRIPTION'" class="type">
            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 5.5C0.447715 5.5 0 5.94772 0 6.5C0 7.05228 0.447715 7.5 1 7.5V5.5ZM18 7.5C18.5523 7.5 19 7.05228 19 6.5C19 5.94772 18.5523 5.5 18 5.5V7.5ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM18 2C18.5523 2 19 1.55228 19 1C19 0.447715 18.5523 0 18 0V2ZM1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13V11ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11V13ZM1 7.5H18V5.5H1V7.5ZM1 2H18V0H1V2ZM1 13H18V11H1V13Z"
                fill="#81858E" />
            </svg>
            <div>
              <h6>{{ $t('views.cobranca.text_2159') }}</h6>
              <p>
                {{ $t('views.cobranca.text_2160') }}
              </p>
            </div>
            <b-form-checkbox v-model="permite_parcela_boleto" name="permite_parcela_boleto" size="lg" switch>
            </b-form-checkbox>
          </div>
          <b-row v-if="validMethod() && permite_parcela_boleto && offerChargeType !== 'SUBSCRIPTION'">
            <b-col class="border-bottom mb-4 pb-4" cols="12">
              <b-form-group label="Qtd de parcelas" label-for="max_boleto_installments" v-if="permite_parcela_boleto"
                data-anima="top" class="col-md-2">
                <b-form-select id="parcelas_boleto" name="max_boleto_installments" v-model="max_boleto_installments"
                  :options=option_boleto_installments></b-form-select>
              </b-form-group>
              <b-form-invalid-feedback :state="!errors.has('max_boleto_installments')">
                {{ $t('views.cobranca.text_2162') }}
              </b-form-invalid-feedback>
            </b-col>
            <div v-if="boleto_fine_interest_beta_seller" class="type col-12">
              <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 5.5C0.447715 5.5 0 5.94772 0 6.5C0 7.05228 0.447715 7.5 1 7.5V5.5ZM18 7.5C18.5523 7.5 19 7.05228 19 6.5C19 5.94772 18.5523 5.5 18 5.5V7.5ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM18 2C18.5523 2 19 1.55228 19 1C19 0.447715 18.5523 0 18 0V2ZM1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13V11ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11V13ZM1 7.5H18V5.5H1V7.5ZM1 2H18V0H1V2ZM1 13H18V11H1V13Z"
                  fill="#81858E" />
              </svg>
              <div>
                <h6>{{ $t('views.cobranca.text_915') }}</h6>
                <p>
                  {{ $t('views.cobranca.text_916') }}
                </p>
                <ul class="list-group">
                  <li class="border-0 list-group-item pl-3 small text-muted">1. {{ $t('views.cobranca.text_917') }}</li>
                  <li class="border-0 list-group-item pl-3 small text-muted">2. {{ $t('views.cobranca.text_918') }}</li>
                </ul>
              </div>
              <b-form-checkbox v-model="boleto_fine_interest" name="boleto_fine_interest  " size="lg" switch>
              </b-form-checkbox>
            </div>
          </b-row>
          <!-- // -->
          
          <!-- Adicionar multa e juros para boleto inadimplente? -->
          <b-row v-if="validMethod() && offerChargeType === 'SUBSCRIPTION' && boleto_fine_interest_beta_seller">
            <div class="type col-12">
              <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 5.5C0.447715 5.5 0 5.94772 0 6.5C0 7.05228 0.447715 7.5 1 7.5V5.5ZM18 7.5C18.5523 7.5 19 7.05228 19 6.5C19 5.94772 18.5523 5.5 18 5.5V7.5ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM18 2C18.5523 2 19 1.55228 19 1C19 0.447715 18.5523 0 18 0V2ZM1 11C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13V11ZM18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11V13ZM1 7.5H18V5.5H1V7.5ZM1 2H18V0H1V2ZM1 13H18V11H1V13Z"
                  fill="#81858E" />
              </svg>
              <div>
                <h6>{{ $t('views.cobranca.text_915') }}</h6>
                <p>
                  {{ $t('views.cobranca.text_916') }}
                </p>
                <ul class="list-group">
                  <li class="border-0 list-group-item pl-3 small text-muted">1. {{ $t('views.cobranca.text_917') }}</li>
                  <li class="border-0 list-group-item pl-3 small text-muted">2. {{ $t('views.cobranca.text_918') }}</li>
                </ul>
              </div>
              <b-form-checkbox v-model="boleto_fine_interest" name="boleto_fine_interest  " size="lg" switch>
              </b-form-checkbox>
            </div>
          </b-row>

          <div class="type">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.5146 10.5249L17.2218 11.2319L17.2239 11.2298L16.5146 10.5249ZM10.5308 16.5103L9.82357 15.8033L9.82318 15.8037L10.5308 16.5103ZM8.16894 16.5103L8.87654 15.8037L8.87573 15.8029L8.16894 16.5103ZM1 9.34787H0C0 9.61324 0.105481 9.86773 0.293213 10.0553L1 9.34787ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM9.34568 1L10.0529 0.292986C9.86534 0.105393 9.61095 0 9.34568 0V1ZM16.5146 8.17082L17.2239 7.46591L17.2218 7.4638L16.5146 8.17082ZM5.17284 4.17393C4.62056 4.17393 4.17284 4.62165 4.17284 5.17393C4.17284 5.72622 4.62056 6.17393 5.17284 6.17393V4.17393ZM5.18119 6.17393C5.73347 6.17393 6.18119 5.72622 6.18119 5.17393C6.18119 4.62165 5.73347 4.17393 5.18119 4.17393V6.17393ZM15.8074 9.8179L9.82357 15.8033L11.238 17.2174L17.2218 11.2319L15.8074 9.8179ZM9.82318 15.8037C9.76102 15.866 9.68722 15.9153 9.60601 15.949L10.3721 17.7965C10.6961 17.6621 10.9905 17.4652 11.2384 17.217L9.82318 15.8037ZM9.60601 15.949C9.5248 15.9827 9.43776 16 9.34986 16V18C9.70066 18 10.048 17.9308 10.3721 17.7965L9.60601 15.949ZM9.34986 16C9.26196 16 9.17491 15.9827 9.0937 15.949L8.32765 17.7965C8.6517 17.9308 8.99906 18 9.34986 18V16ZM9.0937 15.949C9.01249 15.9153 8.93869 15.866 8.87654 15.8037L7.46135 17.217C7.70923 17.4652 8.0036 17.6621 8.32765 17.7965L9.0937 15.949ZM8.87573 15.8029L1.70679 8.64044L0.293213 10.0553L7.46216 17.2178L8.87573 15.8029ZM2 9.34787V1H0V9.34787H2ZM1 2H9.34568V0H1V2ZM8.63848 1.70701L15.8074 8.87783L17.2218 7.4638L10.0529 0.292986L8.63848 1.70701ZM15.8053 8.87573C15.93 9.00116 16 9.17089 16 9.34787H18C18 8.64269 17.721 7.96611 17.2239 7.46591L15.8053 8.87573ZM16 9.34787C16 9.52484 15.93 9.69458 15.8053 9.82001L17.2239 11.2298C17.721 10.7296 18 10.053 18 9.34787H16ZM5.17284 6.17393H5.18119V4.17393H5.17284V6.17393Z"
                fill="#81858E" />
            </svg>

            <div>
              <h6>{{ $t('views.cobranca.text_2163') }}</h6>
              <p>
                {{ $t('views.cobranca.text_2164') }}
              </p>
            </div>
            <b-form-checkbox v-model="allowed_coupon" name="allowed_coupon" size="lg" switch>
            </b-form-checkbox>
          </div>
          <!-- Adicionar multa e juros para boleto inadimplente? -->
          
          <div class="type" v-if="showNoInterestInstallments()">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.8946 2.51961C14.2851 2.12908 14.2851 1.49592 13.8946 1.10539C13.5041 0.714869 12.8709 0.714869 12.4804 1.10539L13.8946 2.51961ZM1.10539 12.4804C0.714869 12.8709 0.714869 13.5041 1.10539 13.8946C1.49592 14.2851 2.12908 14.2851 2.51961 13.8946L1.10539 12.4804ZM12.4804 1.10539L1.10539 12.4804L2.51961 13.8946L13.8946 2.51961L12.4804 1.10539ZM4.0625 3.03125C4.0625 3.60079 3.60079 4.0625 3.03125 4.0625V6.0625C4.70536 6.0625 6.0625 4.70536 6.0625 3.03125H4.0625ZM3.03125 4.0625C2.46171 4.0625 2 3.60079 2 3.03125H0C0 4.70536 1.35714 6.0625 3.03125 6.0625V4.0625ZM2 3.03125C2 2.46171 2.46171 2 3.03125 2V0C1.35714 0 0 1.35714 0 3.03125H2ZM3.03125 2C3.60079 2 4.0625 2.46171 4.0625 3.03125H6.0625C6.0625 1.35714 4.70536 0 3.03125 0V2ZM13 11.9688C13 12.5383 12.5383 13 11.9688 13V15C13.6429 15 15 13.6429 15 11.9688H13ZM11.9688 13C11.3992 13 10.9375 12.5383 10.9375 11.9688H8.9375C8.9375 13.6429 10.2946 15 11.9688 15V13ZM10.9375 11.9688C10.9375 11.3992 11.3992 10.9375 11.9688 10.9375V8.9375C10.2946 8.9375 8.9375 10.2946 8.9375 11.9688H10.9375ZM11.9688 10.9375C12.5383 10.9375 13 11.3992 13 11.9688H15C15 10.2946 13.6429 8.9375 11.9688 8.9375V10.9375Z"
                fill="#81858E" />
            </svg>

            <div>
              <h6>{{ $t('views.cobranca.text_2165') }}</h6>
              <p>
                {{ $t('views.cobranca.text_2166') }}
              </p>
            </div>
            <b-form-checkbox v-model="no_interest_installments" name="no_interest_installments" size="lg" switch>
            </b-form-checkbox>
          </div>
        </div>
      </b-form>
      <div class="flex-footer">
        <BaseButton variant="link-info" class="mr-4" @click="cancel">
          {{ $t('views.cobranca.text_2167') }}
        </BaseButton>
        <BaseButton variant="info2" :disabled="submit" @click="onSubmit">
          {{ $t('views.cobranca.text_909') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from "@/services/resources/ProductService";
const serviceProduct = ProductService.build();

import CurrencyService from "@/services/resources/CurrencyService";
const serviceCurrency = CurrencyService.build();

import { symbolCurrency, textMethod, textMethodType } from "@/helpers.js";
import Money2 from "@/mixins/money";
import Utils from "@/mixins/utils";
import { Money } from "v-money";
import Vue from "vue";
import Multiselect from "vue-multiselect";
import { paymentMethodsString } from "../../../config/paymentMethods";
import { buildLegacyCheckoutUrl } from "@/helpers/checkoutUrl";
import CopyLinkCard from "@/components/shared/CopyLinkCard";
import {
  getPosGraduationMinPrice,
  formatMinPrice,
} from "@/helpers/posGraduationMinPrice";

export default {
  name: "Cobranca",
  components: {
    Money,
    Multiselect,
    CopyLinkCard,
  },
  mixins: [Utils, Money2],
  props: [
    "isMobile",
    "warranty",
    "id_product",
    "methods",
    "option_fixed_installments",
    "installment_limits",
    "installment_limits_by_charge_type",
    "co_sellers_list",
    "product",
  ],
  watch: {
    option_fixed_installments() {
      this.option_fixed_installments_ = this.option_fixed_installments;
    },
    max_subscription_installments(value) {
      this.changeParcelasCard(value);
    },
    trial(value) {
      if (value && value > 0) {
        this.has_enrollment_fee = false;
        this.enrollment_amount = 0;
        this.enrollmentAmountTouched = false;
        if (this.method && this.method.length > 0) {
          this.method = this.method.filter(m => m.value !== 'PIX');
        }
      }
    }
  },
  data() {
    return {
      trial: "",
      renderComponent: true,
      charges: null,
      no_interest_installments: false,
      allowed_coupon: false,
      permite_parcela_boleto: false,
      boleto_fine_interest: true,
      max_boleto_installments: 1,
      amount: "",
      method: [],
      methods_: [],
      currencie_id: 1,
      allCurrencies: [],
      charge_type: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      name: "",
      make: false,
      offers: [],
      loading: false,
      submit: false,
      interAccess: false,
      defaultValue: 0,
      defaultValueCurrency: "R$",
      editItem: null,
      period: 365,
      fixed_installments: null,
      max_installments: 1,
      max_subscription_installments: 1,
      pre_selected_installment: 1,
      option_fixed_installments_: [],
      option_pre_selected_installment: [],
      subscription_installments: [],
      periods: [
        { value: 30, text: this.$t('views.seller.edit_product.text_2284') },
        { value: 90, text: this.$t('views.seller.edit_product.text_2285') },
        { value: 180, text: this.$t('views.seller.edit_product.text_2286') },
        { value: 365, text: this.$t('views.seller.edit_product.text_2287') },
      ],
      isOfferWebhookBetaSeller: false,
      isPixSubscriptionBetaSeller: false,
      modality: null,
      submodality: null,
      disableEditPrice: false,
      has_enrollment_fee: false,
      enrollment_amount: 0,
      enrollmentAmountTouched: false,
      isEnrollmentBetaSeller: false,
      selectedCheckoutOffer: null,
      showCheckoutLinksModal: false,
    };
  },
  created() {
    let userInterIds = process.env.USER_INTER.substring(1, process.env.USER_INTER.length - 1).split(',')
    this.interAccess = userInterIds.some(userId => parseInt(userId) === this.userID)
  },
  computed: {
    viewInstallment() {
      return this.method.some(x => x.value === "CREDIT_CARD");
    },
    // KYC pendente bloqueia os links, exceto em produtos de Pós-Graduação
    isLinkLocked() {
      return this.isProductLinkLocked(this.product);
    },
    baseURL() {
      return process.env.VUE_SALES_PAGE;
    },
    checkoutLinkById() {
      if (!this.selectedCheckoutOffer) return '';
      return `${this.baseURL.replace(/\/$/, '')}/${this.id_product}/offer/${this.selectedCheckoutOffer.hash}`;
    },
    checkoutLinkByHash() {
      const hash = this.product?.checkout_hash;
      if (!hash || !this.selectedCheckoutOffer) return '';
      return `${this.baseURL.replace(/\/$/, '')}/${hash}/offer/${this.selectedCheckoutOffer.hash}`;
    },
    editOfferIsDisable() {
      return false;
    },
    // VADM-5217: mínimo de Pós-Graduação do get-user (null = regra não se aplica).
    // Só vale na criação; editar oferta existente não é afetado (preço é bloqueado).
    posGraduationMinPrice() {
      if (this.editItem) return null;
      return getPosGraduationMinPrice(
        this.$store.getters.getProfile,
        this.product && this.product.format
      );
    },
    posGraduationMinPriceLabel() {
      return this.posGraduationMinPrice === null
        ? ""
        : formatMinPrice(this.posGraduationMinPrice);
    },
    posGraduationAmountInvalid() {
      return (
        this.posGraduationMinPrice !== null &&
        Number(this.amount) < this.posGraduationMinPrice
      );
    },
    boleto_fine_interest_beta_seller() {
      return this.userProfile ? this.userProfile.boleto_fine_interest_beta_seller : false;
    },
    // Tipo de cobrança da oferta em criação/edição; sem tipo próprio, vale o do produto.
    offerChargeType() {
      return this.charge_type || this.product.type;
    },
    // Escolher o tipo só na criação e só para seller no beta (o back valida também).
    canChooseChargeType() {
      return !this.editItem && this.product.can_mix_offer_charge_types === true;
    },
    chargeTypeOptions() {
      return [
        { value: "TRANSACTION", text: this.$t('views.cobranca.text_2137') },
        { value: "SUBSCRIPTION", text: this.$t('views.cobranca.text_2136') },
      ];
    },
    // Oferta de assinatura só aceita BRL.
    currencies() {
      return this.allCurrencies
        .filter((currency) => this.offerChargeType !== "SUBSCRIPTION" || currency.currency === "BRL")
        .map((currency) => ({ id: currency.id, name: currency.name }));
    },
    // Tetos de parcela do tipo da oferta; sem o mapa por tipo, os do produto.
    offerInstallmentLimits() {
      const byChargeType = this.installment_limits_by_charge_type;
      return (byChargeType && byChargeType[this.offerChargeType]) || this.installment_limits;
    },
    // VMPG-3086: opcoes de parcelamento de boleto baseadas em installment_limits.BOLETO
    option_boleto_installments() {
      const max = this.offerInstallmentLimits?.BOLETO || 12
      return Array.from({ length: max }, (_, i) => ({
        value: i + 1,
        text: i === 0 ? this.$t('views.seller.edit_product.text_2290') : this.$t('views.cobranca.text_2403') + ' ' + (i + 1) + 'x'
      }))
    },
    // VMPG-3086: opcoes de parcelamento de CC baseadas em installment_limits.CREDIT_CARD
    option_cc_installments() {
      const max = this.offerInstallmentLimits?.CREDIT_CARD || 12
      return Array.from({ length: max }, (_, i) => ({
        value: i + 1,
        text: i === 0 ? this.$t('views.seller.edit_product.text_2290') : this.$t('views.cobranca.text_2403') + ' ' + (i + 1) + 'x'
      }))
    },
  },
  methods: {
    async onCopyClick(item) {
      if (this.isLinkLocked) {
        return;
      }
      this.selectedCheckoutOffer = item;
      await this.issueCheckoutToken();
      this.showCheckoutLinksModal = true;
    },
    openCheckoutLink(link) {
      window.open(link, '_blank', 'noopener');
    },
    copyCheckoutLink(link) {
      navigator.clipboard.writeText(link).then(() => {
        this.$bvToast.toast('Link copiado com sucesso!', {
          title: 'Checkout',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      });
    },
    async issueCheckoutToken() {
      if (/^[A-Za-z0-9]{16}$/.test(this.product?.checkout_hash || '')) return;

      try {
        const response = await service.post(`/${this.id_product}/checkout-hash`, {});
        this.$set(this.product, 'checkout_hash', response.checkout_hash);
      } catch (error) {
        console.error('Erro ao gerar o novo link do checkout:', error);
        this.$bvToast.toast('Não foi possível preparar o novo link do checkout.', {
          title: 'Checkout',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    chargeTypeOf(offer) {
      return (offer && offer.charge_type) || this.product.type;
    },
    chargeTypeLabel(offer) {
      return this.chargeTypeOf(offer) === "SUBSCRIPTION"
        ? this.$t('views.cobranca.text_2136')
        : this.$t('views.cobranca.text_2137');
    },
    onChargeTypeChange(type) {
      this.charge_type = type;

      // Parcelamento muda de regra entre os tipos: volta ao padrão de uma oferta nova.
      this.fixed_installments = null;
      this.pre_selected_installment = 1;
      this.max_installments = 1;
      this.max_subscription_installments = 1;
      this.permite_parcela_boleto = false;
      this.max_boleto_installments = 1;

      if (type === "SUBSCRIPTION") {
        if (this.currencie_id !== 1) {
          this.currencie_id = 1;
          this.changeCurrency(1);
        }
      } else {
        this.period = 365;
        this.trial = "";
        this.charges = null;
        this.has_enrollment_fee = false;
        this.enrollment_amount = 0;
        this.enrollmentAmountTouched = false;
      }

      const validMethods = this.filterBy(this.methods_).map((x) => x.value);
      this.method = this.method.filter((x) => validMethods.includes(x.value));

      this.changeParcelasSub();
    },
    isShowPreSelectedInstallment() {
      if (this.fixed_installments === null) {
        return (this.offerChargeType === "SUBSCRIPTION")
          ? this.max_subscription_installments > 1
          : this.max_installments > 1;
      }

      return false;
    },
    filterBy(e) {
      const methods = e;
      let array = [];

      if (this.offerChargeType === "SUBSCRIPTION") {
        const isPixEnabled = this.isPixSubscriptionBetaSeller;
        const hasTrialPeriod = this.trial && parseInt(this.trial) > 0;

        array = methods
          .filter(element => 
            element.value === 'CREDIT_CARD' || 
            element.value === 'BOLETO' || 
            (isPixEnabled && element.value === 'PIX')
          )
          .map(element => {
            if (element.value === 'PIX' && hasTrialPeriod) {
              return {
                ...element,
                name: 'PIX (Indisponível com período de avaliação ativo)',
                $isDisabled: true
              };
            }
            return element;
          });
      } else {
        array = methods
      }

      return array;
    },
    isMethodDisabled(option) {
      return option.$isDisabled === true;
    },
    filterCurrency(id) {
      if (id) {
        return symbolCurrency(id);
      }
      return "R$";
    },
    getStatus(status) {
      let r = {};
      if (status) {
        switch (status.toUpperCase()) {
          case "APPROVED": {
            r = { text: this.$t('views.cobranca.text_2410'), class: "is-green" };
            break;
          }
          case "PENDING": {
            r = { text: this.$t('views.cobranca.text_2411'), class: "is-warning" };
            break;
          }
          case "DISAPPROVED": {
            r = {
              text: this.$t('views.cobranca.text_2412'),
              class: "is-red",
            };
            break;
          }
          default: {
            r = { text: status, class: "is-black" };
            break;
          }
        }
        return r;
      } else return { text: status, class: "is-black" };
    },
    validMethod() {
      let result = false;
      this.method.forEach((x) => {
        if (x.value === "BOLETO") result = true;
      });
      return result;
    },
    validStatusNew() {
      var offers = this.offers;
      var result = offers.filter((x) => x.status === "PENDING");

      if (JSON.stringify(result) === "[]") {
        if (
          this.product.status === "PENDING" ||
          this.product.status === "DISAPPROVED" ||
          this.product.status === "REQUESTED"
        ) {
          return this.$t('views.cobranca.text_2408');
        }
        return false;
      } else {
        if (
          this.product.status === "PENDING" ||
          this.product.status === "DISAPPROVED" ||
          this.product.status === "REQUESTED"
        ) {
          return this.$t('views.cobranca.text_2408');
        }
        return this.$t('views.cobranca.text_2409');
      }
    },
    validStatus(status) {
      var offers = this.offers;
      var result = offers.filter(
        (x) => x.status === "PENDING" && x.default === 1
      );

      if (JSON.stringify(result) === "[]") {
        if (status === "PENDING" || status === "DISAPPROVED") {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    voltar() {
      this.$validator.pause();
      this.make = false;
      this.$emit("changeValue", false);
    },
    changeParcelasCard(value) {
      let totalParcelas = this.max_installments;

      if (value && this.offerChargeType == 'SUBSCRIPTION') {
        totalParcelas = value;
      }

      if (totalParcelas < this.pre_selected_installment || this.pre_selected_installment === null) {
        this.pre_selected_installment = 1;
      }

      this.option_pre_selected_installment = [];

      for (let installment = 1; installment <= totalParcelas; installment++) {

        const text = installment === 1
          ? this.$t('views.seller.edit_product.text_2290')
          : `${this.$t('views.cobranca.text_2403')} ${installment}x`;

        this.option_pre_selected_installment.push({ value: installment, text });
      }
    },
    changeParcelasSub() {
      var period = this.period;
      if (this.offerChargeType !== "SUBSCRIPTION") {
        period = 365;
      }
      if (period === 30) {
        this.fixed_installments = null;
        this.pre_selected_installment = null;
        return;
      }
      this.fixed_installments = null;
      let totalParcelas = 0;
      switch (period) {
        case 90: {
          totalParcelas = 3;
          break;
        }
        case 180: {
          totalParcelas = 6;
          break;
        }
        case 365: {
          totalParcelas = this.offerChargeType !== 'SUBSCRIPTION'
            ? (this.offerInstallmentLimits?.CREDIT_CARD || 12)
            : 12;
        }
      }

      this.option_fixed_installments_ = [
        { value: null, text: this.$t('views.cobranca.text_2404') },
      ];

      this.subscription_installments = [];
      this.option_pre_selected_installment = [];

      for (let installment = 1; installment <= totalParcelas; installment++) {
        const text = installment === 1
          ? this.$t('views.seller.edit_product.text_2290')
          : `${this.$t('views.cobranca.text_2403')} ${installment}x`;

        const option = { value: installment, text };

        if (installment > 1) {
          this.option_fixed_installments_.push(option);
        }

        this.option_pre_selected_installment.push(option);
        this.subscription_installments.push(option);
      }
    },
    makeNew(item) {
      this.$emit("changeValue", true);
      this.name = this.product.name;
    },
    async editOffer(item) {
      this.charge_type = this.chargeTypeOf(item);
      this.disableEditPrice = true;

      if (this.offerChargeType !== 'SUBSCRIPTION' && item.max_boleto_installments === 0) {
        this.permite_parcela_boleto = false;
        this.max_boleto_installments = 1;
      } else if (item.max_boleto_installments) {
        this.permite_parcela_boleto = item.max_boleto_installments !== 0 ? true : false;
        this.max_boleto_installments = item.max_boleto_installments;
      } else {
        this.permite_parcela_boleto = false;
        this.max_boleto_installments = 0;
      }

      if (item.max_boleto_installments === 0 && this.offerChargeType !== 'SUBSCRIPTION') {
        this.max_boleto_installments = 1;
        item.max_boleto_installments = 1;
      }

      if (item.method === null) {
        item.method = '';
      }

      var methodItem = item.method.split(",");

      if (item.currency_id) {
        this.currencie_id = item.currency_id;
      } else {
        this.currencie_id = 1;
      }

      let getAllMethods = await this.changeCurrency(this.currencie_id, "MOUNTED");

      var methodAll = this.methods_;

      var arrayMethod = [];

      if (methodItem[0] === "ALL") {
        for (let i = 0; i < methodAll.length; i++) {
          const elementAll = methodAll[i];
          arrayMethod.push(elementAll);
        }
      } else {
        for (let i = 0; i < methodAll.length; i++) {
          const elementAll = methodAll[i];
          for (let x = 0; x < methodItem.length; x++) {
            const elementItem = methodItem[x];
            if (elementAll.value === elementItem) {
              if (this.offerChargeType === "SUBSCRIPTION" && (elementAll.value === 'CREDIT_CARD' || elementAll.value === 'BOLETO')) {
                arrayMethod.push(elementAll);
              } else {
                arrayMethod.push(elementAll);
              }
            }
          }
        }
      }

      if (
        item.max_installments &&
        item.max_installments !== 1 &&
        item.max_installments !== ""
      ) {
        this.max_installments = item.max_installments;
      } else {
        this.max_installments = 12;
      }

      if (item.boleto_fine_interest === 1 && (this.permite_parcela_boleto === true || this.offerChargeType === "SUBSCRIPTION")) {
        this.boleto_fine_interest = true;
      } else {
        this.boleto_fine_interest = false;
      }

      if (item.no_interest_installments === 1) {
        this.no_interest_installments = true;
      } else {
        this.no_interest_installments = false;
      }

      if (item.allowed_coupon === 1) {
        this.allowed_coupon = true;
      } else {
        this.allowed_coupon = false;
      }

      if (item.pre_selected_installment) {
        this.pre_selected_installment = item.pre_selected_installment;
      } else {
        this.pre_selected_installment = item.pre_selected_installment;
      }

      if (item.max_installments) {
        this.max_installments = item.max_installments;
      } else {
        this.max_installments = 12;
      }

      if (item.max_subscription_installments) {
        this.max_subscription_installments = item.max_subscription_installments;
      } else {
        this.max_subscription_installments = 12;
      }

      if (item.modality) {
        this.modality = item.modality;
      } else {
        this.modality = null;
      }

      if (item.submodality) {
        this.submodality = item.submodality;
      } else {
        this.submodality = null;
      }

      if (item.enrollment_amount && item.enrollment_amount > 0) {
        this.has_enrollment_fee = true;
        this.enrollment_amount = item.enrollment_amount;
        this.enrollmentAmountTouched = false;
      } else {
        this.has_enrollment_fee = false;
        this.enrollment_amount = 0;
        this.enrollmentAmountTouched = false;
      }

      this.$emit("changeValue", true);
      this.editItem = item;
      this.name = item.name;
      this.trial = item.trial;
      this.charges = item.charges;
      this.period = item.period;

      if (this.offerChargeType !== "SUBSCRIPTION") {
        this.period = 365;
      }

      (this.amount = item.amount), (this.method = arrayMethod);

      await this.changeParcelasSub();

      if (
        item.fixed_installments &&
        item.fixed_installments !== 1 &&
        item.fixed_installments !== ""
      ) {
        this.fixed_installments = item.fixed_installments;
      } else {
        this.fixed_installments = null;
      }

      this.changeParcelasCard(this.max_subscription_installments);

      this.make = true;
    },
    copyLink(item) {
      const el = document.createElement("textarea");
      el.value = buildLegacyCheckoutUrl(this.baseURL, this.product, {
        offerHash: item.hash,
      });

      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$bvToast.toast(
        this.$t('views.cobranca.text_910'),
        {
          title: this.$t('views.cobranca.text_2394'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        }
      );
    },
    filterDefault() {
      var offers = this.offers;
      for (let i = 0; i < offers.length; i++) {
        const offer = offers[i];
        if (offer.default === 1) {
          this.defaultValue = offer.amount;
          this.defaultValueCurrency = offer.currency_id;
        }
      }
    },
    changeDefault(item) {
      if (item.default === 1) {
        this.$bvToast.toast(this.$t('views.cobranca.text_2168'), {
          title: this.$t('views.cobranca.text_2169'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        return
      }
      // Cópia: não muta o item da lista. charge_type não vai no update (não pode mudar).
      const data = { ...item, id: this.id_product + "/offers/" + item.id, default: 1 };
      delete data.charge_type;
      delete data.created_at;
      delete data.updated_at;

      this.loading = true;
      serviceProduct
        .update(data)
        .then((response) => {
          this.resolveResponse();
          this.filterDefault();
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    deleteOffer(item, index) {
      if (item.default === 1) {
        this.$bvToast.toast(this.$t('views.cobranca.text_911'), {
          title: this.$t('views.cobranca.text_2169'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        return;
      }
      Vue.swal({
        title: this.$t('views.cobranca.text_897'),
        text: `${this.$t('views.cobranca.text_912')} ${item.name}?`,
        type: "danger",
        showCancelButton: true,
        confirmButtonText: this.$t('views.cobranca.text_2395'),
        cancelButtonText: this.$t('views.cobranca.text_2167'),
        customClass: "sweet-container",
        confirmButtonClass: "button button-danger mt-3 mb-3",
        cancelButtonClass: "button button-link-info mr-4 mt-3 mb-3",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;

          let data = {
            id: this.id_product + "/offers/" + item.id,
          };
          serviceProduct
            .destroy(data)
            .then((response) => {
              this.$bvToast.toast(this.$t('views.cobranca.text_913'), {
                title: this.$t('views.cobranca.text_2169'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
              this.offers.splice(index, 1);
              this.$emit("offersLoaded", this.offers);
            })
            .catch(err => {
              console.error(err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    getMethod(method) {
      if (method === "ALL") {
        return "Todos";
      } else if (method === null) {
        return ''
      }
      method = method.split(",");
      var array = [];
      for (let i = 0; i < method.length; i++) {
        const element = textMethod(method[i]);
        array.push(element);
      }
      return array.toString();
    },
    reset() {
      this.editItem = null;
      this.charge_type = this.product.type;
      if (this.charge_type !== "SUBSCRIPTION") {
        this.period = 365;
      }
      this.max_boleto_installments = 1;
      this.no_interest_installments = false;
      this.allowed_coupon = false;
      this.boleto_fine_interest = true;
      this.permite_parcela_boleto = false;
      this.amount = "";
      this.name = "";
      this.currencie_id = 1,
        this.method = [];
      this.max_installments = 1;
      this.max_subscription_installments = 1;
      this.pre_selected_installment = 1;
      this.fixed_installments = null;
      this.disableEditPrice = false;
      this.has_enrollment_fee = false;
      this.enrollment_amount = 0;
      this.enrollmentAmountTouched = false;
    },
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    cancel() {
      this.$validator.pause();
      this.make = false;
      this.$emit("changeValue", false);
      this.fetchOffers();
      this.reset();
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit = true;
          var method = this.method;
          var array_method = [];
          for (let i = 0; i < method.length; i++) {
            const element = method[i];
            array_method.push(element.value);
          }

          if (!array_method.join().length) {
            this.$bvToast.toast(this.$t('views.cobranca.text_2402'), {
              title: this.$t('views.cobranca.text_2169'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.submit = false;
            return;
          }

          if (this.posGraduationAmountInvalid) {
            this.$bvToast.toast(
              `${this.$t("views.cobranca.pos_graduation_min_price_error")} ${this.posGraduationMinPriceLabel}`,
              {
                title: this.$t('views.cobranca.text_2169'),
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
            this.submit = false;
            return;
          }

          if (this.co_sellers_list && this.co_sellers_list.length) {
            if (this.amount < 15) {
              this.$bvToast.toast(`${this.$t("views.cobranca.text_2401")} 15,00`, {
                title: this.$t('views.cobranca.text_2169'),
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              });
              this.submit = false;
              return;
            }
          } else {
            if (this.amount < 9) {
              this.$bvToast.toast(`${this.$t("views.cobranca.text_2400")} 9,00`, {
                title: this.$t('views.cobranca.text_2169'),
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              });
              this.submit = false;
              return;
            }
          }

          if (this.isOfferWebhookBetaSeller === true && this.modality === null) {
            this.$bvToast.toast(`${this.$t("views.cobranca.description_valid_modality")}`, {
              title: this.$t('views.cobranca.text_2169'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.submit = false;
            return;
          }

          if (this.isOfferWebhookBetaSeller === true && this.submodality === null) {
            this.$bvToast.toast(`${this.$t("views.cobranca.description_valid_submodality")}`, {
              title: this.$t('views.cobranca.text_2169'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.submit = false;
            return;
          }

          if (this.has_enrollment_fee && this.enrollment_amount <= 0) {
            this.$bvToast.toast(`${this.$t("views.cobranca.enrollment_fee_required")}`, {
              title: this.$t('views.cobranca.text_2169'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.submit = false;
            return;
          }

          if (this.has_enrollment_fee && this.enrollment_amount < 9) {
            this.$bvToast.toast(`${this.$t("views.cobranca.enrollment_fee_min_value")} R$ 9,00`, {
              title: this.$t('views.cobranca.text_2169'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.submit = false;
            return;
          }

          // Parcela fixa: teto de cartão = valor fixo (não 1). Evita 422 no checkout.
          if (this.fixed_installments) {
            this.pre_selected_installment = null;
            this.max_subscription_installments = this.fixed_installments;
            this.max_installments = this.fixed_installments;
          }

          let errorMessage = null;

          let data = {
            id: this.id_product + "/offers",
            method: array_method.join(),
            name: this.name,
            currency_id: this.currencie_id,
            amount: this.amount,
            fixed_installments: this.fixed_installments,
            allowed_coupon: this.allowed_coupon,
            default: 0,
            no_interest_installments: this.no_interest_installments,
            pre_selected_installment: this.pre_selected_installment,
            modality: this.modality,
            submodality: this.submodality,
          };

          // O tipo só vai na criação: na edição ele não muda.
          if (!this.editItem) {
            data.charge_type = this.offerChargeType;
          }

          if (this.offerChargeType === "SUBSCRIPTION") {
            data.period = this.period;
            data.charges = this.charges || null;
            data.trial = (this.trial === "") ? 0 : this.trial;
            data.max_subscription_installments = this.max_subscription_installments || 1;
            data.enrollment_amount = this.has_enrollment_fee ? this.enrollment_amount : null;

            if (this.max_subscription_installments === 1) {
              data.pre_selected_installment = null;
            }

            // validação parcelas de assinatura
            if (this.period > 30) {
              if (this.period == 90 && this.max_subscription_installments > 3) {
                errorMessage = this.$t('views.cobranca.text_2397');
              }

              if (this.period == 180 && this.max_subscription_installments > 6) {
                errorMessage = this.$t('views.cobranca.text_2398');
              }

              if (this.period == 365 && this.max_subscription_installments > 12) {
                errorMessage = this.$t('views.cobranca.text_2399');
              }

              // Com parcela fixa o pré-selecionado fica oculto (null); não exigir.
              if (
                this.max_subscription_installments > 1 &&
                !data.pre_selected_installment &&
                !this.fixed_installments
              ) {
                errorMessage = this.$t('views.cobranca.text_2170');
              }
            }

          } else {
            data.max_installments = this.max_installments || 1;

            if (
              this.max_installments > 1 &&
              !data.pre_selected_installment &&
              !this.fixed_installments
            ) {
              errorMessage = this.$t('views.cobranca.text_2170');
            }

            if (this.permite_parcela_boleto === false) {
              this.max_boleto_installments = 0;
            }
          }

          if (errorMessage) {
            this.$bvToast.toast(errorMessage, {
              title: this.$t('views.cobranca.text_2396'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });

            if (document.querySelector("#subscription_installments")) {
              document.querySelector("#subscription_installments").focus();
            }

            this.submit = false;
            return;
          }


          if (this.permite_parcela_boleto) {
            data.max_boleto_installments = this.max_boleto_installments;
          } else {
            data.max_boleto_installments = 0;
          }

          if (this.permite_parcela_boleto || this.offerChargeType === "SUBSCRIPTION") {
            data.boleto_fine_interest = this.boleto_fine_interest;
          } else {
            data.boleto_fine_interest = false;
          }

          if (this.editItem) {
            data.id = this.id_product + "/offers/" + this.editItem.id;
            serviceProduct
              .update(data)
              .then((response) => {
                this.resolveResponse();
                this.submit = false;
              })
              .catch(err => {
                console.error(err);
                this.submit = false;
              });
            return;
          }

          serviceProduct
            .createId(data)
            .then((response) => {
              this.resolveResponse();
              this.submit = false;
            })
            .catch(err => {
              console.error(err);
              this.submit = false;
            });
        }
      });
    },
    resolveResponse() {
      this.$bvToast.toast(this.$t('views.cobranca.text_914'), {
        title: this.$t('views.cobranca.text_2169'),
        variant: "success",
        autoHideDelay: 5000,
        appendToast: true,
      });
      this.reset();
      this.fetchOffers();
      this.$validator.pause();
      this.make = false;
      this.$emit("changeValue", false);

    },
    async changeCurrency(value, mounted) {
      await this.forceRerender();
      let data = {
        id: "/payment_methods/" + value,
      };

      this.money.prefix = symbolCurrency(value);

      serviceCurrency
        .read(data)
        .then((response) => {
          if (mounted === undefined) {
            this.method = [];
          }
          this.methods_ = [];
          response.forEach((element) => {
            if (paymentMethodsString.toLowerCase().split(',').includes(element.payment_methods.name))
              this.methods_.push({
                value: textMethodType(element.payment_methods.name).toUpperCase(),
                name: textMethod(element.payment_methods.name).toUpperCase(),
              });
          });
          this.forceRerender();
        })
        .catch(err => console.error(err));
    },
    fetchCurrency() {
      let data = {
        id: "/currencies",
      };

      this.allCurrencies = [];

      serviceCurrency
        .read(data)
        .then((response) => {
          response.forEach((element) => {
            this.allCurrencies.push({
              id: element.id,
              name: element.name,
              currency: element.currency,
            });
          });
        })
        .catch(err => console.error(err));
    },
    fetchOffers() {
      this.loading = true;
      let data = {
        id: this.id_product + "/offers",
      };

      serviceProduct
        .read(data)
        .then((response) => {
          this.offers = response;
          this.filterDefault();
          this.$emit("offersLoaded", this.offers);
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    showNoInterestInstallments() {
      const index = this.method.findIndex((i) => i.value === 'CREDIT_CARD');
      return index >= 0;
    },
    async checkOfferWebhookBetaSeller() {
      const isBeta = await this.$store.dispatch('checkBetaSeller', 'OFFER_WEBHOOK_BETA_SELLERS')
      this.isOfferWebhookBetaSeller = isBeta
      console.log('this.isOfferWebhookBetaSeller', this.isOfferWebhookBetaSeller)
    },
    async checkEnrollmentBetaSeller() {
      await this.$store.dispatch('checkBetaSeller', 'ROLLOUT_CHECKOUT_ENROLLMENT_AMOUNT_ALLOW_BETA_SELLERS')
      this.isEnrollmentBetaSeller = this.$store.getters.isBetaSeller
      console.log('this.isEnrollmentBetaSeller', this.isEnrollmentBetaSeller)
    },
    async checkPixSubscriptionBetaSeller() {
      const isBeta = await this.$store.dispatch('checkBetaSeller', 'ROLLOUT_CHECKOUT_PIX_SUBSCRIPTION_ALLOW_BETA_SELLERS')
      this.isPixSubscriptionBetaSeller = isBeta
      console.log('this.isPixSubscriptionBetaSeller', this.isPixSubscriptionBetaSeller)
    },
  },
  mounted() {
    this.methods_ = this.methods;
    this.fetchOffers();
    this.fetchCurrency();
    this.changeCurrency(1, "MOUNTED");
    this.checkOfferWebhookBetaSeller();
    this.checkEnrollmentBetaSeller();
    this.checkPixSubscriptionBetaSeller();
  },
};
</script>

<style lang="scss" scoped>
.method-disabled {
  color: #9ca3af;
}

h5,
p {
  margin: 0;
}

h5 {
  margin-bottom: 20px;
  color: #0d0d0f;
  font-weight: 600;
  font-size: 14px;
}

p {
  font-weight: normal;
  font-size: 13px;
  color: #81858e;
}

h2 {
  font-weight: 500;
  font-size: 24px;
  color: #333;
}

#id_venda {
  position: relative;
}

.flex-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.copy-link {
  width: 15px;
  /* margin-left: 20px; */
  filter: invert(50%);
  cursor: pointer;
  transition: 0.3s ease;
}

.copy-link:hover {
  filter: invert(0);
}

#id_venda::before {
  content: "";
  width: 15px;
  height: 15px;
  background: transparent;
  border-radius: 50%;
  display: block;
  position: absolute;
  left: -25px;
  top: 0;
}

.text-table {
  font-weight: normal !important;
  font-size: 13px !important;
  color: #333333;
}

.default {
  background: rgba(0, 33, 99, 0.1);
  border-radius: 5px;
  height: 27px;
  text-align: center;
  padding: 4px 1px;
  position: relative;
  left: -10px;
  color: #002363 !important;
  font-weight: 500 !important;

  display: block;
  width: 110px;
}

.btn-more {
  background: rgba(0, 35, 99, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 19px 15px;
  border-radius: 5px;
}

.type {
  display: grid;
  grid-template-columns: 60px 4fr 60px;
  align-items: center;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: solid 1px #ededf0;

  h6 {
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
}

.info-value {
  margin-top: 25px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

.arrow {
  position: relative;
  left: -15px;
}

.pointer {
  cursor: pointer;
}

.value-base {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr 1fr;

  svg {
    margin-left: 10px;
  }
}

.flex-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-footer {
  display: flex;
  justify-content: flex-end;
}

.is-invalid {
  border-color: #dc3545 !important;
}

.offer-charge-type {
  font-size: 12px;
  color: #81858e;
}

.charge-type-label {
  font-size: 14px;
  color: #333;
}

.checkout-link-loading {
  margin-bottom: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f4f8ff;
  color: #667085;
  font-size: 13px;
}
</style>
